import React, { useState, useRef, useEffect } from 'react';
import '../../App.css';
import { API_URL } from '../../config';
import BottomMenu from '../layout/BottomMenu';

const ChatInput = React.forwardRef(({onSendMessage, userConversationId, onSubmit, userId, productType}, ref) => {
  //console.log("子组件收到的参数是:", userConversationId);
  const accumulatedTextRef = useRef(""); // 后端传来的总文本
  const displayedTextRef = useRef("");   // 界面已经显示的文本
  const [messages, setMessages] = useState([]);
  const [inputText, setInputText] = useState('');
  const [isTextareaDisabled, setIsTextareaDisabled] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const textareaRef = useRef(null);
  const [isFocused, setIsFocused] = useState(false);
  const conversationIdRef = useRef(null); // 存储 type: -1 的 ID
  const timerRef = useRef(null); // 1. 创建一个 Ref 用来存放定时器 ID

  const restorMessage = (message, bUser, answer ) => {
    setMessages(prevMessages => [...prevMessages, { text: message, isUser: bUser, answer: answer }]);
  };

  // 将子组件中的函数通过 ref 暴露给父组件
  React.useImperativeHandle(ref, () => ({
    ParentHandleSendMessage,
    childFunction
  }));

  const childFunction = () => {
    if(conversationIdRef.current){
        conversationIdRef.current = null;
      }
  };

  /**
   * 失去焦点
  */
  const handleBlur = () => {
    setIsFocused(false);
    //console.log('Textarea is blurred');
  };

  const handleFocus = (e) => {
    // 延迟执行是为了等待软键盘弹出完成
    setTimeout(() => {
      e.target.scrollIntoView({
        behavior: 'smooth', 
        block: 'center' // 将输入框滚动到屏幕中间，避免被输入法上边缘贴死
      });
    }, 300);
  };

  const enableInput = () => {
    setIsTextareaDisabled(false);
    setIsButtonDisabled(false);
     // 设置焦点到<textarea>
    if (textareaRef.current) {
      textareaRef.current.readOnly = false;
      //textareaRef.current.focus();
    }
  };

  const disableInput = () => {
    setIsTextareaDisabled(true);
    setIsButtonDisabled(true);
  };

  const adjustHeight = () => {
    const textarea = textareaRef.current;
    if (textarea) {
      if(inputText.length < 30){
        textarea.style.height = "48px"; // 先重置高度
      }else{
        textarea.style.height = "auto"; // 先重置高度
        textarea.style.height = `${textarea.scrollHeight}px`; // 根据内容调整高度
      }
    }
  };

  const stopRenderText = () => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }
  };

  useEffect(() => {
    // 在组件渲染后，如果textarea不可用，则不设置焦点
    if (!isTextareaDisabled && textareaRef.current) {
      textareaRef.current.readOnly = false;
      //.current.focus();
    }
    adjustHeight();

  }, [isTextareaDisabled, userConversationId]);

  const handleInputChange = (e) => {
    setInputText(e.target.value);
    if(e.target.value.length > 30){
      e.target.style.height = 'auto'; // 重置高度以便重新计算
      e.target.style.height = `${e.target.scrollHeight}px`; // 设置高度为滚动高度
    }
    else{
      e.target.style.height = '48px';
    }
  };

  function startRenderText(){
    // 如果当前已经有定时器在跑，先清除，防止出现多个定时器竞争
    stopRenderText();

    // 2. 将 setInterval 的返回值赋给 timerRef.current
    timerRef.current  = setInterval(() => {
      const total = accumulatedTextRef.current;
      const displayed = displayedTextRef.current;
      if (total.length > displayed.length) {
        // 每次根据剩余量动态决定步长，内容多时快一点，内容少时细水长流
        const step = Math.ceil(total.length  / 100) || 1; 
        const nextText = total.substring(displayed.length, displayed.length + step);
        
        displayedTextRef.current += nextText;
        onSendMessage(nextText, false, false, null, 1, null);
      } else if (total.length > 0 && total.length === displayed.length) {
        // --- 关键判断：请求结束了，且字也打完了，才清理 ---
        stopRenderText();
        console.log("所有内容显示完毕，定时器关闭");
        onSendMessage('', false, false, null, 3, null);
      }
    }, 40); // 40ms 刷新率，视觉非常平滑

  }
  

  const handleSendPost = async (paramBody, messageAll, strType = "") =>
  {
    accumulatedTextRef.current = "";
    displayedTextRef.current = "";
    let strData = {
			question: paramBody,
      userId: userId,
      productType: strType !== "" ? strType : productType,
		};
    if(conversationIdRef.current){
      strData.userConversationId = conversationIdRef.current;
    }
    if(userConversationId){
      strData.userConversationId = userConversationId;
    }
    
    let json = JSON.stringify(strData)
    console.log("json: " + json)
    startRenderText();
    console.log("开始开启定时器...");
    try {
      let getData = false;
      const startTime = performance.now(); // 获取高精度开始时间
      const response = await fetch(`${API_URL}/getAnswer/v2`, {
        method: 'POST', // 1. 指定请求方法
        headers: {
          'Content-Type': 'application/json', // 2. 告诉后端你发送的是 JSON
          "Accept": "application/json" 
        },
        body: json
      });
      const endTime = performance.now(); // 获取结束时间
      const timeTaken = endTime - startTime;
      if(getData === false){
        console.log(`请求耗时: ${timeTaken} 毫秒 时间戳: ${new Date().toISOString()}`);
        getData = true;
      }
      
      const reader = response.body.getReader();
      const decoder = new TextDecoder();
      onSendMessage('', false, false, null, 0);
      // 提前准备一个缓冲区，防止数据包被截断导致的解析失败
      let buffer = ''; 
     
      while (true) {
        const { done, value } = await reader.read();
        if (done) {
          // 2. 结束后，确保缓冲区剩余内容全部渲染
          //onSendMessage(bufferText, false, false, null, 1);
          break;
        }
       
        // 解码并合并到缓冲区
        buffer += decoder.decode(value, { stream: true });

        // 按换行符分割，处理每一行
        const lines = buffer.split('\n');
        
        // 最后一行可能不完整，保留到下一次循环处理
        buffer = lines.pop(); 
        console.log("Received value:", lines);
        // console.log("Received chunk:", lines);
        for (let line of lines) {
          const trimmedLine = line.trim();
          if (!trimmedLine || !trimmedLine.startsWith('data:')) continue;

          try {
            const jsonStr = trimmedLine.replace('data:', '').trim();
            const parseData = JSON.parse(jsonStr);
            
            // --- 核心逻辑：判断数据流结束 ---
            if (parseData.data === null) {
              console.log("收到结束信号：", parseData.msg);
              return; // 终止函数，停止后续处理
            }

            const innerData = parseData.data;

            switch (innerData.type) {
              case -1: // 会话 ID
                conversationIdRef.current = innerData.userConversationId;
                break;

              case 0: // 问答内容
                  if(innerData.type === 0 && typeof innerData.answer === 'string') {
                    const textChunk = innerData.answer;
                    if (textChunk) {
                      accumulatedTextRef.current += textChunk;
                    }
                  }
                break;
              case 1: // 调参
                console.log('处理调参逻辑');
                //data.answer:ai回答
                // data.strategy:策略对应的id(1,2,3,4...)
                //data.earSide: 左右耳
                let serverAudioParams = {
                  strategy: innerData.strategy,
                  earSide: innerData.earSide,
                  value: innerData.value
                };
                //console.error('解析JSON数据', serverAudioParams);
                stopRenderText();
                onSendMessage(innerData.answer, false, false, null, 2, serverAudioParams);
                break;
            }
          } catch (err) {
            console.error('解析单行JSON失败', err);
          }
        }
      }
    } catch (error) {
      console.error("流传输错误", error);
    } finally {
      enableInput();
    }

  }

  const handleSendMessage = () => {
    if (inputText.trim() !== '') {
      stopRenderText();
      restorMessage(inputText, true);
      onSendMessage(inputText, true);
      setInputText('');
      let lastFourMessages = messages;
      if (messages.length >= 7){
        lastFourMessages = messages.slice(-2);
      }
      
      let messageAll = ""
      lastFourMessages.map((msg, index) => (
        messageAll += msg.text +"\n"
      ))
      handleSendPost(inputText, messageAll)
      disableInput()
    }
  };

  const ParentHandleSendMessage = (inputValue, productType0) => {
    console.log("parent call", productType0, userId)
    if (inputValue.trim() !== '') {
      stopRenderText();
      restorMessage(inputValue, true);
      onSendMessage(inputValue, true);
      setInputText('');
      let lastFourMessages = messages;
      if (messages.length >= 7){
        lastFourMessages = messages.slice(-2);
      }

      let messageAll = ""
      lastFourMessages.map((msg, index) => (
        messageAll += msg.text +"\n"
      ))
      handleSendPost(inputValue, messageAll, productType0)
      disableInput()
    }
  };

  

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault(); // 阻止换行
    }
  };

  const [btnStyle, setBtnStyle] = useState({
    width: '100px',
    height: '30px',
    marginLeft: '20px',
    borderRadius: '8px'
  });

  // 步骤 1: 定义父组件中的处理函数
  const handleMenuClick = (actionName) => {
    console.log(`动作名称是: ${actionName}`);
    onSubmit();
  };

  return (
    <div className="chat-input-out">
      <BottomMenu onMenuClick={handleMenuClick} />
      <div className="chat-input">
        <div className="text-container">
          <textarea className='textarea-css'
            //disabled={isTextareaDisabled}
            cols="100"
            ref={textareaRef}
            placeholder="Type your message..."
            value={inputText}
            onKeyDown={handleKeyDown}
            onChange={handleInputChange}
                    onBlur={handleBlur}
                    onFocus={handleFocus}
          />

          <button  className='send-button'
            onClick={handleSendMessage}
            disabled={isButtonDisabled || inputText.trim() === ''}
            >
          </button>
        </div>
        
      </div>
      <div className='chat-tips-div'>Responses are generated by AI</div>
    </div>
  );
});

export default ChatInput;
